// @ts-nocheck
/**
 * アドベンチャーモード メイン画面
 */

import React from 'react';
import { useAdventure } from '../hooks/useAdventure';
import { ChapterTabs } from './ChapterTabs';
import { NpcCard } from './NpcCard';
import { NpcDetailModal } from './NpcDetailModal';
import { BattleResultModal } from './BattleResultModal';
import { getChapterConfig } from '../data/constants';
import {
  screenStyles,
  chapterHeaderStyles,
} from '../styles/adventureStyles';

interface AdventureScreenProps {
  onBack: () => void;
  onStartBattle: (config: any) => void;
  isMobile?: boolean;
}

export const AdventureScreen: React.FC<AdventureScreenProps> = ({
  onBack,
  onStartBattle,
  isMobile = false,
}) => {
  const {
    progress,
    selectedChapter,
    selectedNpc,
    isDetailOpen,
    isResultOpen,
    lastBattleResult,
    chapters,
    currentChapterNpcs,
    clearProgress,
    selectChapter,
    selectNpc,
    closeDetail,
    startBattle,
    handleBattleEnd,
    closeResult,
  } = useAdventure();

  // 現在の章情報
  const currentChapterConfig = getChapterConfig(selectedChapter);
  const currentChapterDisplay = chapters.find((c) => c.id === selectedChapter);

  // 対戦開始ハンドラ
  const handleStartBattle = (npcId: string) => {
    const config = startBattle(npcId);
    if (config) {
      // handleBattleEnd コールバックを含めて渡す
      onStartBattle({
        ...config,
        onBattleEnd: handleBattleEnd,
      });
    }
  };

  return (
    <div
      style={{
        ...screenStyles.container,
        ...(isMobile ? screenStyles.containerMobile : screenStyles.containerDesktop),
      }}
    >
      {/* ヘッダー */}
      {isMobile ? (
        <div style={screenStyles.headerMobile}>
          <button style={screenStyles.backButton} onClick={onBack}>
            ← 戻る
          </button>
          <h1 style={{ ...screenStyles.title, ...screenStyles.titleMobile }}>
            アドベンチャー
          </h1>
          <div style={{ fontSize: '14px', color: '#ffd700' }}>
            {clearProgress.cleared}/{clearProgress.total}
          </div>
        </div>
      ) : (
        <div style={screenStyles.header}>
          <button style={screenStyles.backButton} onClick={onBack}>
            ← 戻る
          </button>
          <h1 style={screenStyles.title}>⚔️ アドベンチャー</h1>
          <div style={{ fontSize: '16px', color: '#a0a0a0' }}>
            進行: {clearProgress.cleared}/{clearProgress.total} ({clearProgress.percentage}%)
          </div>
        </div>
      )}

      {/* 章タブ */}
      <ChapterTabs
        chapters={chapters}
        selectedChapter={selectedChapter}
        onSelectChapter={selectChapter}
        isMobile={isMobile}
      />

      {/* 章ヘッダー */}
      {currentChapterConfig && currentChapterDisplay && (
        <div style={chapterHeaderStyles.container}>
          <h2 style={chapterHeaderStyles.title}>
            第{currentChapterConfig.id}章: {currentChapterConfig.name}
          </h2>
          <p style={chapterHeaderStyles.description}>
            {currentChapterConfig.description}
          </p>
          <div style={chapterHeaderStyles.progress}>
            <div style={chapterHeaderStyles.progressBar}>
              <div
                style={{
                  ...chapterHeaderStyles.progressFill,
                  width: `${(currentChapterDisplay.progress.cleared / currentChapterDisplay.progress.total) * 100}%`,
                }}
              />
            </div>
            <span style={chapterHeaderStyles.progressText}>
              {currentChapterDisplay.progress.cleared}/{currentChapterDisplay.progress.total}
            </span>
          </div>
        </div>
      )}

      {/* NPC一覧 */}
      <div>
        {currentChapterNpcs.map((npc) => (
          <NpcCard
            key={npc.npcId}
            npc={npc}
            onClick={() => selectNpc(npc.npcId)}
            isMobile={isMobile}
          />
        ))}
      </div>

      {/* NPC詳細モーダル */}
      <NpcDetailModal
        npcId={selectedNpc}
        progress={progress}
        isOpen={isDetailOpen}
        onClose={closeDetail}
        onStartBattle={handleStartBattle}
      />

      {/* 結果モーダル */}
      <BattleResultModal
        isOpen={isResultOpen}
        isWin={lastBattleResult?.gold > 0 || lastBattleResult?.isFirstClear}
        npcId={selectedNpc}
        reward={lastBattleResult}
        onClose={closeResult}
      />
    </div>
  );
};

export default AdventureScreen;
